import React, { useEffect, useState } from "react";
import "./EditRoutineGroup.scss";
import { useParams, useNavigate } from "react-router-dom";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import Loader from "../../../components/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import Swal from "sweetalert2";

const EditRoutineGroup = () => {
  const {
    day,
    enrollmentSetupId,
    routinePeriodId,
    programId,
    semesterId,
    curriculumSectionMapId,
  } = useParams();

  const [routines, setRoutines] = useState([]);
  const [faculty, setFaculty] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const fetchRoutines = async () => {
    setIsLoading(true);
    try {
      const response = await adminRequest.post(
        `${BASE_URL}/routine/group/details`,
        {
          day,
          enrollmentSetupId,
          routinePeriodId,
          program: programId,
          semester: semesterId,
          curriculumSectionMapId,
        },
      );
      const data = response.data.data;
      setRoutines(
        data.map((item) => ({
          uuid: item.uuid,
          subject: item.subject,
          facultyId: item.faculty?.id || "",
          timeSlotId: item.timeSlot?.id || "",
          room: item.room || "",
          day: item.day,
        })),
      );
    } catch (err) {
      toast.error("Failed to load group routines.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSupportingData = async () => {
    try {
      const [facultyRes, timeSlotRes] = await Promise.all([
        adminRequest.get(`${BASE_URL}/faculty/getNameAndId`),
        adminRequest.get(`${BASE_URL}/timeSlot/list`),
      ]);
      setFaculty(facultyRes.data.faculties);
      setTimeSlots(timeSlotRes.data.data);
    } catch (err) {
      console.log("Error loading faculty or timeslots", err);
    }
  };

  useEffect(() => {
    fetchSupportingData();
    fetchRoutines();
  }, []);

  const handleChange = (index, name, value) => {
    const updated = [...routines];
    updated[index][name] = value;
    setRoutines(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/routine/update/group`, routines),
        { pending: "Processing your request..." },
      );

      Swal.fire({
        title: "SUCCESS",
        icon: "success",
        confirmButtonColor: "#264796",
        text: response.data.message,
        confirmButtonText: "OK",
      }).then(() => navigate(-1));
    } catch (error) {
      Swal.fire({
        title: "UPDATING ROUTINE FAILED",
        icon: "error",
        confirmButtonColor: "#264796",
        text: error.response?.data?.message,
        confirmButtonText: "OK",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) return <Loader />;

  return (
    <div className="createPageContainer">
      <div className="createPageContents">
        <div className="top">
          <span className="backIcon" onClick={handleBackClick}>
            <FaArrowLeftLong />
          </span>
          <span className="headerTitle">Edit Routine Group</span>
        </div>
        <div className="bottom">
          <form onSubmit={handleSubmit}>
            {routines.map((routine, index) => (
              <div
                className="formGroup"
                key={routine.uuid}
                style={{ width: "100%" }}
              >
                <div className="inputGroup">
                  <label>Subject</label>
                  <input type="text" value={routine.subject} disabled />
                </div>

                <div className="inputGroup">
                  <label>Faculty</label>
                  <select
                    value={routine.facultyId}
                    onChange={(e) =>
                      handleChange(index, "facultyId", e.target.value)
                    }
                  >
                    <option value="">Select Faculty</option>
                    {faculty.map((f) => (
                      <option key={f.id} value={f.id}>
                        {f.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="inputGroup">
                  <label>Time Slot</label>
                  <select
                    value={routine.timeSlotId}
                    onChange={(e) =>
                      handleChange(index, "timeSlotId", e.target.value)
                    }
                  >
                    <option value="">Select Time Slot</option>
                    {timeSlots.map((slot) => (
                      <option key={slot.id} value={slot.id}>
                        {slot.startTime} - {slot.endTime}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="inputGroup">
                  <label>Room</label>
                  <input
                    type="text"
                    value={routine.room}
                    onChange={(e) =>
                      handleChange(index, "room", e.target.value)
                    }
                  />
                </div>
              </div>
            ))}

            <div className="btn-group">
              <button
                className="create-btn"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Processing" : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer position="top-center" />
    </div>
  );
};

export default EditRoutineGroup;
